module.exports = __webpack_public_path__ + "img/dy06.5aa698a8.png";